/**
 * ScheduleTimeline — 청약일정 6단계 타임라인 (v2 목업 `.tl`).
 *
 * 순수 프레젠테이션. 단계는 domain/property/detailV2.buildScheduleSteps 결과(날짜 없는 단계는 이미 제외).
 * done = 회색 점, now = 오렌지 점 + 링, upcoming = 빈 점. 외부 링크(청약홈·모집공고) 없음.
 */

import React from 'react';
import type { ScheduleStep } from '../../../domain/property/detailV2';
import { SectionCard } from './SectionCard';
import { CalendarIcon } from './SectionIcons';

const STATE_LABEL: Record<ScheduleStep['state'], string> = {
  done: '완료',
  now: '진행중',
  upcoming: '예정',
};

export interface ScheduleTimelineProps {
  title?: string;
  steps: ScheduleStep[];
}

export function ScheduleTimeline({ title = '청약 일정', steps }: ScheduleTimelineProps) {
  if (steps.length === 0) return null;
  return (
    <SectionCard title={title} icon={<CalendarIcon />}>
      <ol className="relative pl-[22px]">
        <span aria-hidden className="absolute bottom-1.5 left-[5px] top-1.5 w-0.5 bg-ca-surface" />
        {steps.map((s) => {
          const now = s.state === 'now';
          return (
            <li key={s.key} className="relative flex justify-between gap-2.5 pb-3.5 last:pb-0" data-step-state={s.state}>
              <i
                aria-hidden
                className={`absolute left-[-22px] top-0.5 h-3 w-3 rounded-full border-2 border-white ${
                  s.state === 'done'
                    ? 'bg-body'
                    : now
                      ? 'bg-accent shadow-[0_0_0_4px_var(--ca-accent-50)]'
                      : 'bg-ca-surface shadow-[0_0_0_1px_var(--ca-line)]'
                }`}
              />
              <div className="min-w-0">
                <div className={`text-[12px] font-semibold leading-4 ${now ? 'font-bold text-accent' : 'text-muted'}`}>
                  {s.label}
                </div>
                <b className={`num text-[14px] leading-5 ${s.state === 'upcoming' ? 'text-body' : 'text-ink'}`}>{s.date}</b>
              </div>
              <span className={`shrink-0 text-[11px] font-bold leading-[14px] ${now ? 'text-accent' : 'text-mute2'}`}>
                {STATE_LABEL[s.state]}
              </span>
            </li>
          );
        })}
      </ol>
    </SectionCard>
  );
}

export default ScheduleTimeline;
